import { render } from "./THissue.vue?vue&type=template&id=1f379d5e&scoped=true"
import script from "./THissue.vue?vue&type=script&lang=js"
export * from "./THissue.vue?vue&type=script&lang=js"

import "./THissue.vue?vue&type=style&index=0&id=1f379d5e&lang=scss&scoped=true"
import "./THissue.vue?vue&type=style&index=1&id=1f379d5e&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f379d5e"]])

export default __exports__